import { useState } from 'react';

/** Фото профиля или первая буква имени (если фото нет или оно не загрузилось). */
export function Avatar({ url, name, className = '' }: { url?: string | null; name: string; className?: string }) {
  const [broken, setBroken] = useState(false);
  return (
    <span className={`avatar ${className}`} aria-hidden>
      {url && !broken ? <img src={url} alt="" loading="lazy" decoding="async" onError={() => setBroken(true)} /> : (name || '?').slice(0, 1).toUpperCase()}
    </span>
  );
}
